export enum Role {
    ADMIN = "ROLE_ADMIN",
    CIUDADANO = "ROLE_CIUDADANO",
    CONSULTOR = "ROLE_CONSULTOR",
    CONCESIONARIO = "ROLE_CONCESIONARIO",
    CEA = "ROLE_CEA",
    CIA = "ROLE_CIA",
    CRC = "ROLE_CRC"
}